// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'D:/company/code-2025/gitragfllow/ragflow/web/node_modules/.pnpm/@umijs+renderer-react@4.4.6_3abd5af8b0f99c47e4cecd4d9a5ce87f/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
